import { render, staticRenderFns } from "./AuctionChat.vue?vue&type=template&id=94c5da9e&"
import script from "./AuctionChat.vue?vue&type=script&lang=js&"
export * from "./AuctionChat.vue?vue&type=script&lang=js&"
import style0 from "./AuctionChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports